// @ts-nocheck

(() => {
  console.info('[JDGM Scroll] script loaded', window.location.href);

  if (window.__jdgmSummaryTruncateInitialized) {
    return;
  }

  window.__jdgmSummaryTruncateInitialized = true;

  const MAX_CHARS = 3;
  const MIN_RECOMMENDED_RATING = 4;
  const TARGET_SELECTOR = '.jdgm-rev-widg__summary-average';
  const SUMMARY_SELECTOR = '.jdgm-rev-widg__summary';
  const SUMMARY_ROW_SELECTOR = '.jdgm-row-stars';
  const HISTOGRAM_ROW_SELECTOR = '.jdgm-histogram__row';
  const HISTOGRAM_SELECTOR = '.jdgm-histogram';
  const HISTOGRAM_TITLE_SELECTOR = '.jdgm-histogram__title-custom';
  const HISTOGRAM_TITLE_TEXT = 'Rating Distribution';
  const WIDGET_SELECTOR = '.jdgm-widget, .jdgm-rev-widg';
  const SORT_WRAPPER_SELECTOR = '.jdgm-rev-widg__sort-wrapper';
  const SORT_LABEL_SELECTOR = '.jdgm-rev-widg__sort-label-custom';
  const SORT_LABEL_TEXT = 'SORT BY';
  const HISTOGRAM_FREQUENCY_SELECTOR = '.jdgm-histogram__frequency';
  const HISTOGRAM_STAR_SELECTOR = '.jdgm-histogram__star';
  const RECOMMENDATION_SELECTOR = '.jdgm-rev-widg__summary-recommendation';
  const RECOMMENDATION_VALUE_SELECTOR = '.jdgm-rev-widg__summary-recommendation-value';
  const RECOMMENDATION_LABEL_SELECTOR = '.jdgm-rev-widg__summary-recommendation-label';
  const VERIFIED_SUMMARY_SELECTOR = '.jdgm-all-reviews__summary-text--verified';
  const REVIEW_HASHES = ['#judgeme_product_reviews', '#reviews'];
  const REVIEW_QUERY_KEYS = ['scroll_to_reviews', 'reviews_scroll'];
  const DEBUG_QUERY_PARAM = 'jdgm_scroll_debug=1';
  const DEBUG_STORAGE_KEY = 'jdgmScrollDebug';
  const REVIEW_TARGET_SELECTORS = [
    '#judgeme_product_reviews',
    '.jdgm-widget',
    '.jdgm-rev-widg',
  ];
  const REVIEW_SCROLL_EXTRA_GAP = -120;
  const REVIEW_SCROLL_EXTRA_GAP_MOBILE = -80;
  const VERIFIED_SLICE_START = 9;
  const RECOMMENDATION_LABEL = 'would recommend this product to a friend';
  const CUSTOM_ENHANCEMENT_SELECTOR = [
    HISTOGRAM_TITLE_SELECTOR,
    SORT_LABEL_SELECTOR,
    RECOMMENDATION_SELECTOR,
    RECOMMENDATION_VALUE_SELECTOR,
    RECOMMENDATION_LABEL_SELECTOR,
  ].join(', ');
  const originalTextByNode = new WeakMap();

  const readDebugStorageFlag = () => {
    try {
      return window.localStorage && window.localStorage.getItem(DEBUG_STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const isDebugEnabled = () => {
    const hasQueryDebug = window.location.search.includes(DEBUG_QUERY_PARAM);
    const hasHashDebug = window.location.hash.includes('jdgm_scroll_debug=1');
    const hasRuntimeDebug = window.JDGM_SCROLL_DEBUG === true;

    return hasQueryDebug || hasHashDebug || hasRuntimeDebug || readDebugStorageFlag();
  };

  const logDebug = (...args) => {
    if (isDebugEnabled()) {
      console.info('[JDGM Scroll]', ...args);
    }
  };

  const ensureJudgeMeCompatibility = () => {
    const jdgm = window.jdgm;

    if (!jdgm || typeof jdgm !== 'object') {
      return false;
    }

    if (typeof jdgm._setupYtInput !== 'function') {
      jdgm._setupYtInput = () => {};
      logDebug('Patched missing jdgm._setupYtInput with no-op');
      return true;
    }

    return false;
  };

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isElementVisible = (node) => {
    if (!(node instanceof HTMLElement)) {
      return false;
    }

    return node.getClientRects().length > 0;
  };

  const isReviewHash = (hashValue) => {
    if (typeof hashValue !== 'string' || !hashValue.length) {
      return false;
    }

    const normalizedHash = hashValue.toLowerCase();
    return REVIEW_HASHES.some((reviewHash) => normalizedHash.startsWith(reviewHash));
  };

  const hasReviewScrollQuery = () => {
    try {
      const searchParams = new URLSearchParams(window.location.search || '');
      return REVIEW_QUERY_KEYS.some((key) => searchParams.has(key));
    } catch (error) {
      return false;
    }
  };

  const truncateToChars = (text, maxChars) => {
    const normalizedText = text.trim().replace(/\s+/g, ' ');

    if (normalizedText.length <= maxChars) {
      return normalizedText;
    }

    return normalizedText.slice(0, maxChars);
  };

  const truncateTextNode = (textNode) => {
    if (!(textNode instanceof Text)) {
      return;
    }

    const currentText = textNode.textContent || '';
    const normalizedCurrentText = currentText.trim().replace(/\s+/g, ' ');

    if (!normalizedCurrentText) {
      return;
    }

    if (!originalTextByNode.has(textNode)) {
      originalTextByNode.set(textNode, currentText);
    }

    const originalText = originalTextByNode.get(textNode) || currentText;
    const truncated = truncateToChars(originalText, MAX_CHARS);

    if (textNode.textContent !== truncated) {
      textNode.textContent = truncated;
    }
  };

  const truncateAverageNode = (averageNode) => {
    if (!(averageNode instanceof HTMLElement)) {
      return;
    }

    if (!averageNode.dataset.originalText) {
      averageNode.dataset.originalText = averageNode.textContent || '';
    }

    const originalText = averageNode.dataset.originalText || '';
    const numericValue = originalText.match(/\d+(?:\.\d+)?/)?.[0] || originalText;
    const truncated = truncateToChars(numericValue, MAX_CHARS);

    if (averageNode.textContent !== truncated) {
      averageNode.textContent = truncated;
    }
  };

  const truncateVerifiedSummaryNode = (verifiedNode) => {
    if (!(verifiedNode instanceof HTMLElement)) {
      return;
    }

    if (!verifiedNode.dataset.originalText) {
      verifiedNode.dataset.originalText = verifiedNode.textContent || '';
    }

    const originalText = verifiedNode.dataset.originalText || '';
    const slicedText = originalText.slice(VERIFIED_SLICE_START);

    if (verifiedNode.textContent !== slicedText) {
      verifiedNode.textContent = slicedText;
    }
  };

  const extractNumber = (text) => {
    if (typeof text !== 'string') {
      return null;
    }

    const match = text.replace(/,/g, '').match(/\d+(?:\.\d+)?/);

    return match ? Number(match[0]) : null;
  };

  const upsertHistogramTitle = (histogramNode) => {
    if (!(histogramNode instanceof HTMLElement)) {
      return;
    }

    const existingTitle = histogramNode.querySelector(HISTOGRAM_TITLE_SELECTOR);

    if (existingTitle instanceof HTMLElement) {
      if (existingTitle.textContent !== HISTOGRAM_TITLE_TEXT) {
        existingTitle.textContent = HISTOGRAM_TITLE_TEXT;
      }

      return;
    }

    const titleNode = document.createElement('div');
    titleNode.className = HISTOGRAM_TITLE_SELECTOR.slice(1);
    titleNode.textContent = HISTOGRAM_TITLE_TEXT;
    histogramNode.prepend(titleNode);
  };

  const upsertSortLabel = (sortWrapperNode) => {
    if (!(sortWrapperNode instanceof HTMLElement)) {
      return;
    }

    sortWrapperNode.style.flexWrap = 'wrap';
    sortWrapperNode.style.rowGap = '0.5rem';

    const existingLabel = sortWrapperNode.querySelector(SORT_LABEL_SELECTOR);

    if (existingLabel instanceof HTMLElement) {
      if (existingLabel.textContent !== SORT_LABEL_TEXT) {
        existingLabel.textContent = SORT_LABEL_TEXT;
      }

      existingLabel.style.display = 'block';
      existingLabel.style.flex = '0 0 100%';
      existingLabel.style.width = '100%';
      existingLabel.style.margin = '0';
      existingLabel.style.fontSize = '0.75rem';
      existingLabel.style.fontFamily = 'Geist Mono';
      existingLabel.style.lineHeight = '1.2';
      existingLabel.style.letterSpacing = '0.02em';
      existingLabel.style.textTransform = 'uppercase';
      existingLabel.style.color = '#012326';

      return;
    }

    const labelNode = document.createElement('div');
    labelNode.className = SORT_LABEL_SELECTOR.slice(1);
    labelNode.textContent = SORT_LABEL_TEXT;
    labelNode.style.display = 'block';
    labelNode.style.flex = '0 0 100%';
    labelNode.style.width = '100%';
    labelNode.style.margin = '0';
    labelNode.style.fontSize = '0.75rem';
    labelNode.style.lineHeight = '1.2';
    labelNode.style.letterSpacing = '0.08em';
    labelNode.style.textTransform = 'uppercase';
    labelNode.style.color = 'inherit';
    sortWrapperNode.prepend(labelNode);
  };

  const getRowRating = (row, index, totalRows) => {
    if (!(row instanceof HTMLElement)) {
      return null;
    }

    const datasetRating = extractNumber(
      row.dataset.rating || row.dataset.score || row.getAttribute('data-rating') || ''
    );

    if (datasetRating !== null) {
      return datasetRating;
    }

    const starLabel = row.querySelector(HISTOGRAM_STAR_SELECTOR)?.textContent || '';
    const starRating = extractNumber(starLabel);

    if (starRating !== null) {
      return starRating;
    }

    if (totalRows === 5) {
      return 5 - index;
    }

    return null;
  };

  const getSummaryDataScope = (summaryNode) => {
    if (!(summaryNode instanceof HTMLElement)) {
      return null;
    }

    return summaryNode.closest(SUMMARY_ROW_SELECTOR) || summaryNode.parentElement || summaryNode;
  };

  const calculateRecommendationPercentage = (summaryNode) => {
    if (!(summaryNode instanceof HTMLElement)) {
      return null;
    }

    const dataScope = getSummaryDataScope(summaryNode);

    if (!(dataScope instanceof HTMLElement)) {
      return null;
    }

    const rows = Array.from(dataScope.querySelectorAll(HISTOGRAM_ROW_SELECTOR));

    if (!rows.length) {
      return null;
    }

    let totalReviews = 0;
    let recommendedReviews = 0;

    rows.forEach((row, index) => {
      if (!(row instanceof HTMLElement)) {
        return;
      }

      const frequencyText = row.querySelector(HISTOGRAM_FREQUENCY_SELECTOR)?.textContent || '';
      const reviewCount = extractNumber(frequencyText);
      const rating = getRowRating(row, index, rows.length);

      if (reviewCount === null || rating === null) {
        return;
      }

      totalReviews += reviewCount;

      if (rating >= MIN_RECOMMENDED_RATING) {
        recommendedReviews += reviewCount;
      }
    });

    if (!totalReviews) {
      return null;
    }

    return Math.round((recommendedReviews / totalReviews) * 100);
  };

  const upsertRecommendation = (summaryNode) => {
    if (!(summaryNode instanceof HTMLElement)) {
      return;
    }

    const recommendationPercentage = calculateRecommendationPercentage(summaryNode);
    const lastPercentage = Number(summaryNode.dataset.recommendationPercentage);
    const hasLastPercentage = Number.isFinite(lastPercentage);
    const resolvedPercentage = recommendationPercentage === null
      ? (hasLastPercentage ? lastPercentage : null)
      : recommendationPercentage;
    const existingNode = summaryNode.querySelector(RECOMMENDATION_SELECTOR);

    if (resolvedPercentage === null) {
      return;
    }

    summaryNode.dataset.recommendationPercentage = String(resolvedPercentage);

    const recommendationNode = existingNode || document.createElement('div');
    const valueNode = recommendationNode.querySelector(RECOMMENDATION_VALUE_SELECTOR) || document.createElement('span');
    const labelNode = recommendationNode.querySelector(RECOMMENDATION_LABEL_SELECTOR) || document.createElement('span');

    recommendationNode.className = RECOMMENDATION_SELECTOR.slice(1);
    valueNode.className = RECOMMENDATION_VALUE_SELECTOR.slice(1);
    labelNode.className = RECOMMENDATION_LABEL_SELECTOR.slice(1);

    valueNode.textContent = `${resolvedPercentage}%`;
    labelNode.textContent = RECOMMENDATION_LABEL;

    if (!valueNode.parentNode) {
      recommendationNode.appendChild(valueNode);
    }

    if (!labelNode.parentNode) {
      recommendationNode.appendChild(labelNode);
    }

    if (!recommendationNode.parentNode) {
      summaryNode.appendChild(recommendationNode);
    }
  };

  const applyEnhancements = (root = document) => {
    if (!(root instanceof Document || root instanceof HTMLElement)) {
      return;
    }

    const summaries = root.querySelectorAll(SUMMARY_SELECTOR);

    summaries.forEach((summaryNode) => {
      upsertRecommendation(summaryNode);
    });

    const averages = root.querySelectorAll(TARGET_SELECTOR);

    averages.forEach((averageNode) => {
      if (!(averageNode instanceof HTMLElement)) {
        return;
      }

      truncateAverageNode(averageNode);
    });

    const verifiedSummaries = root.querySelectorAll(VERIFIED_SUMMARY_SELECTOR);

    verifiedSummaries.forEach((verifiedNode) => {
      if (!(verifiedNode instanceof HTMLElement)) {
        return;
      }

      truncateVerifiedSummaryNode(verifiedNode);
    });

    const histograms = root.querySelectorAll(HISTOGRAM_SELECTOR);

    histograms.forEach((histogramNode) => {
      if (!(histogramNode instanceof HTMLElement)) {
        return;
      }

      upsertHistogramTitle(histogramNode);
    });

    const sortWrappers = root.querySelectorAll(SORT_WRAPPER_SELECTOR);

    sortWrappers.forEach((sortWrapperNode) => {
      if (!(sortWrapperNode instanceof HTMLElement)) {
        return;
      }

      upsertSortLabel(sortWrapperNode);
    });
  };

  const getReviewTarget = () => {
    const sectionTitles = Array.from(document.querySelectorAll('.bv-only-text__title--desktop, .bv-only-text__title--mobile, .bv-only-text__title'));
    const customerReviewsVisibleTitle = sectionTitles.find((titleNode) => {
      if (!(titleNode instanceof HTMLElement)) {
        return false;
      }

      return isElementVisible(titleNode) && normalizeText(titleNode.textContent).includes('customer reviews');
    });

    if (customerReviewsVisibleTitle instanceof HTMLElement) {
      logDebug('Using visible section title target', customerReviewsVisibleTitle);
      return customerReviewsVisibleTitle;
    }

    const customerReviewsAnyTitle = sectionTitles.find((titleNode) => {
      if (!(titleNode instanceof HTMLElement)) {
        return false;
      }

      return normalizeText(titleNode.textContent).includes('customer reviews');
    });

    if (customerReviewsAnyTitle instanceof HTMLElement) {
      logDebug('Using hidden/fallback section title target', customerReviewsAnyTitle);
      return customerReviewsAnyTitle;
    }

    for (let i = 0; i < REVIEW_TARGET_SELECTORS.length; i += 1) {
      const target = document.querySelector(REVIEW_TARGET_SELECTORS[i]);
      if (target instanceof HTMLElement) {
        const titleInsideTarget = target.querySelector('.jdgm-rev-widg__title, .jdgm-widget-title, .jdgm-rev-widg__header');
        if (titleInsideTarget instanceof HTMLElement) {
          logDebug('Using title inside target', titleInsideTarget, 'selector:', REVIEW_TARGET_SELECTORS[i]);
          return titleInsideTarget;
        }

        const widgetRoot = target.closest('.jdgm-widget, .jdgm-rev-widg');
        if (widgetRoot instanceof HTMLElement) {
          const titleInsideRoot = widgetRoot.querySelector('.jdgm-rev-widg__title, .jdgm-widget-title, .jdgm-rev-widg__header');
          if (titleInsideRoot instanceof HTMLElement) {
            logDebug('Using title inside widget root', titleInsideRoot);
            return titleInsideRoot;
          }
        }

        const reviewHeadings = Array.from(document.querySelectorAll('h1, h2, h3, h4, h5, h6, .jdgm-rev-widg__title, .jdgm-widget-title'));
        const customerReviewsHeading = reviewHeadings.find((heading) => {
          if (!(heading instanceof HTMLElement)) {
            return false;
          }

          return normalizeText(heading.textContent).includes('customer reviews');
        });

        if (customerReviewsHeading instanceof HTMLElement) {
          logDebug('Using heading fallback target', customerReviewsHeading);
          return customerReviewsHeading;
        }

        logDebug('Using raw review widget target', target, 'selector:', REVIEW_TARGET_SELECTORS[i]);
        return target;
      }
    }

    logDebug('No review target found yet');
    return null;
  };

  const getPreferredScrollTarget = () => {
    const sectionTitles = Array.from(document.querySelectorAll('.bv-only-text__title--desktop, .bv-only-text__title--mobile, .bv-only-text__title'));
    const customerReviewsVisibleTitle = sectionTitles.find((titleNode) => {
      if (!(titleNode instanceof HTMLElement)) {
        return false;
      }

      return isElementVisible(titleNode) && normalizeText(titleNode.textContent).includes('customer reviews');
    });

    if (customerReviewsVisibleTitle instanceof HTMLElement) {
      const parentSection = customerReviewsVisibleTitle.closest('section');
      if (parentSection instanceof HTMLElement) {
        logDebug('Using parent section of CUSTOMER REVIEWS title', parentSection);
        return parentSection;
      }

      return customerReviewsVisibleTitle;
    }

    return getReviewTarget();
  };

  const getHeaderOffset = () => {
    const bodyStyles = window.getComputedStyle(document.body);
    const headerHeightVar = bodyStyles.getPropertyValue('--header-group-height').trim();
    const parsedHeaderHeight = Number.parseFloat(headerHeightVar);

    if (Number.isFinite(parsedHeaderHeight) && parsedHeaderHeight > 0) {
      logDebug('Header offset from CSS variable', parsedHeaderHeight);
      return parsedHeaderHeight;
    }

    const headerGroup = document.querySelector('#header-group');
    if (headerGroup instanceof HTMLElement && headerGroup.offsetHeight > 0) {
      logDebug('Header offset from #header-group', headerGroup.offsetHeight);
      return headerGroup.offsetHeight;
    }

    logDebug('Header offset fallback to 0');
    return 0;
  };

  const scrollToReviewTarget = (target) => {
    if (!(target instanceof HTMLElement)) {
      return;
    }

    const headerOffset = getHeaderOffset();
    const extraGap = window.matchMedia('(max-width: 768px)').matches
      ? REVIEW_SCROLL_EXTRA_GAP_MOBILE
      : REVIEW_SCROLL_EXTRA_GAP;
    const additionalOffset = Math.max(32, window.innerHeight * 0.08) + extraGap;
    const targetTop = target.getBoundingClientRect().top + window.scrollY;
    const scrollTop = Math.max(0, targetTop - headerOffset - additionalOffset);

    logDebug('Scrolling to review target', {
      headerOffset,
      additionalOffset,
      targetTop,
      scrollTop,
      target,
    });

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });

    [350, 900, 1500].forEach((delay) => {
      window.setTimeout(() => {
        const recalculatedTop = target.getBoundingClientRect().top + window.scrollY;
        const recalculatedScrollTop = Math.max(0, recalculatedTop - getHeaderOffset() - additionalOffset);
        window.scrollTo({ top: recalculatedScrollTop, behavior: 'auto' });
        logDebug('Applied follow-up scroll correction', { delay, recalculatedScrollTop, target });
      }, delay);
    });
  };

  const scrollToReviewWidgetFromHash = () => {
    const currentHash = window.location.hash?.toLowerCase?.() || '';
    const shouldScrollFromQuery = hasReviewScrollQuery();
    logDebug('Review scroll trigger check', {
      hash: currentHash,
      fromHash: isReviewHash(currentHash),
      fromQuery: shouldScrollFromQuery,
    });

    if (!isReviewHash(currentHash) && !shouldScrollFromQuery) {
      logDebug('No review trigger found, skipping scroll');
      return;
    }

    let attempt = 0;
    const maxAttempts = 20;
    const attemptScroll = () => {
      logDebug('Scroll attempt', `${attempt + 1}/${maxAttempts}`);
      const target = getPreferredScrollTarget();

      if (target) {
        scrollToReviewTarget(target);
        return;
      }

      attempt += 1;
      if (attempt < maxAttempts) {
        window.setTimeout(attemptScroll, 250);
      } else {
        logDebug('Stopped trying to scroll: max attempts reached');
      }
    };

    attemptScroll();
  };

  const isRelevantWidgetMutationNode = (node) => {
    if (!(node instanceof HTMLElement)) {
      return false;
    }

    if (node.matches(CUSTOM_ENHANCEMENT_SELECTOR) || node.closest(CUSTOM_ENHANCEMENT_SELECTOR)) {
      return false;
    }

    if (!node.closest(WIDGET_SELECTOR) && !node.querySelector(WIDGET_SELECTOR)) {
      return false;
    }

    return node.matches(SUMMARY_SELECTOR)
      || node.matches(SUMMARY_ROW_SELECTOR)
      || node.matches(HISTOGRAM_SELECTOR)
      || node.matches(HISTOGRAM_ROW_SELECTOR)
      || node.matches(SORT_WRAPPER_SELECTOR)
      || node.matches(VERIFIED_SUMMARY_SELECTOR)
      || Boolean(node.querySelector(SUMMARY_SELECTOR))
      || Boolean(node.querySelector(SUMMARY_ROW_SELECTOR))
      || Boolean(node.querySelector(HISTOGRAM_SELECTOR))
      || Boolean(node.querySelector(HISTOGRAM_ROW_SELECTOR))
      || Boolean(node.querySelector(SORT_WRAPPER_SELECTOR))
      || Boolean(node.querySelector(VERIFIED_SUMMARY_SELECTOR));
  };

  const init = () => {
    logDebug('init', {
      href: window.location.href,
      hash: window.location.hash,
      search: window.location.search,
    });

    ensureJudgeMeCompatibility();

    let compatibilityAttempts = 0;
    const compatibilityMaxAttempts = 40;
    const compatibilityInterval = window.setInterval(() => {
      ensureJudgeMeCompatibility();
      compatibilityAttempts += 1;

      if (compatibilityAttempts >= compatibilityMaxAttempts) {
        window.clearInterval(compatibilityInterval);
      }
    }, 250);

    applyEnhancements(document);
    scrollToReviewWidgetFromHash();

    // Judge.me can mount after initial page load.
    window.setTimeout(() => {
      applyEnhancements(document);
    }, 1200);

    let retryCount = 0;
    const maxRetries = 6;
    const retryInterval = window.setInterval(() => {
      applyEnhancements(document);
      retryCount += 1;

      if (retryCount >= maxRetries) {
        window.clearInterval(retryInterval);
      }
    }, 500);

    let isApplyScheduled = false;

    const scheduleApply = () => {
      if (isApplyScheduled) {
        return;
      }

      isApplyScheduled = true;

      window.requestAnimationFrame(() => {
        isApplyScheduled = false;
        applyEnhancements(document);
      });
    };

    const observer = new MutationObserver((mutations) => {
      const hasRelevantMutation = mutations.some((mutation) => {
        if (mutation.type !== 'childList') {
          return false;
        }

        const addedNodes = Array.from(mutation.addedNodes);
        const removedNodes = Array.from(mutation.removedNodes);

        return addedNodes.some(isRelevantWidgetMutationNode)
          || removedNodes.some(isRelevantWidgetMutationNode);
      });

      if (hasRelevantMutation) {
        scheduleApply();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener('hashchange', scrollToReviewWidgetFromHash);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
